var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { NodeState, TreeNode, TreeService } from '../tree/tree.service';
var CurrentUnitService = /** @class */ (function (_super) {
    __extends(CurrentUnitService, _super);
    function CurrentUnitService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    CurrentUnitService.prototype.init = function () {
    };
    CurrentUnitService.prototype.getRecord = function (id) {
        var _this = this;
        this.baseUrl = '/v1/gen/unit-role-api';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            _this.logger.debug('data:', data);
            return data.units;
        }));
    };
    CurrentUnitService.prototype.updateRecord = function (rec, id) {
        this.baseUrl = '/v1/tenant/change';
        return _super.prototype.updateRecord.call(this, rec).pipe(map(function (data) {
            return data;
        }));
    };
    CurrentUnitService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CurrentUnitService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return CurrentUnitService;
}(TreeService));
export { CurrentUnitService };
var CurrentUnitNode = /** @class */ (function (_super) {
    __extends(CurrentUnitNode, _super);
    function CurrentUnitNode(rec) {
        var _this = _super.call(this, rec) || this;
        _this.state = new NodeState();
        _this.li_attr = {};
        _this.a_attr = {};
        return _this;
    }
    return CurrentUnitNode;
}(TreeNode));
export { CurrentUnitNode };
//# sourceMappingURL=currentunit.service.js.map